export default "__VITE_ASSET__e0c0266e__"